import styled from "styled-components";

const FONT_STACK = `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`;

// Ocupa el alto de la pantalla menos navbar + footer, así el footer no queda
// pegado al contenido (el problema que tenía el 404 anterior).
export const NotFoundContainer = styled.div`
  min-height: calc(100vh - 130px);
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
  padding: 2.5rem 1.5rem 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: ${FONT_STACK};
  -webkit-font-smoothing: antialiased;

  @media (max-width: 800px) {
    margin-top: 160px;
    min-height: calc(100vh - 160px);
    padding: 1.5rem 1rem 6rem;
  }
`;

export const Codigo = styled.div`
  font-size: 5.5rem;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.03em;
  background: linear-gradient(180deg, var(--violetaPastelOscuro) 0%, var(--violetaOscuro) 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: 800px) {
    font-size: 4rem;
  }
`;

export const Titulo = styled.h1`
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--violetaOscuro);
  letter-spacing: -0.02em;
  margin: 0.75rem 0 0;
`;

export const Texto = styled.p`
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--grisMedio);
  margin: 0.5rem 0 1.75rem;
  line-height: 1.5;
`;

export const Boton = styled.button`
  font-family: ${FONT_STACK};
  font-weight: 600;
  font-size: 0.85rem;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: white;
  background: linear-gradient(180deg, var(--violetaPastelOscuro) 0%, var(--violetaOscuro) 100%);
  border: none;
  border-radius: 8px;
  padding: 0.85rem 1.75rem;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(76, 4, 140, 0.25);
  transition:
    background 0.15s ease,
    box-shadow 0.15s ease,
    transform 0.08s ease;

  &:hover {
    background: linear-gradient(180deg, var(--violeta) 0%, var(--violetaPastelOscuro) 100%);
    box-shadow: 0 4px 14px rgba(76, 4, 140, 0.38);
  }

  &:active {
    transform: scale(0.98);
  }

  &:focus-visible {
    outline: none;
    box-shadow:
      0 2px 8px rgba(76, 4, 140, 0.25),
      0 0 0 3px rgba(203, 182, 219, 0.45);
  }
`;
